import { Button } from 'primereact/button';
import React, { FC } from 'react';

import tableStore from '../../../../store/TableStore';
import { ModalWindowButtonProps } from './ModalWindowButton.types';

export const ModalWindowButton: FC<ModalWindowButtonProps> = ({
  tableId,
  inSidebar,
  tableDeleted,
}) => (
  <Button
    icon="pi pi-eye"
    className={inSidebar ? 'p-0 w-auto h-auto me-4' : ''}
    disabled={tableDeleted}
    rounded
    text
    severity="success"
    aria-label="View"
    tooltip="Fullscreen"
    onClick={() => tableStore.addViewingModalWindowTable(tableId)}
  />
);
